module.exports = __webpack_public_path__ + "img/m.59033713.png";